import { EntityId } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'
import { RootState } from '@store/store'
import { selectAllPlaylists } from '@store/slices/playlist.slice'
import { selectNarrationsByIds } from '@store/slices/narration.slice'

const selectPlaylistByFromTime = createSelector(
  selectAllPlaylists,
  (state: RootState, fromTime: Date) => fromTime,
  (playlists, fromTime) =>
    playlists.find(
      (playlist) => new Date(playlist.fromTime).getTime() === fromTime.getTime()
    )
)
const getAiSlots = (
  _: RootState,
  aiSlots: Array<{ narrations: EntityId[] }> | null
) => aiSlots
export const selectPlaylistNarrations = createSelector(
  [getAiSlots, (state) => state],
  (aiSlots, state) =>
    aiSlots
      ? selectNarrationsByIds(
          state,
          aiSlots.flatMap((aiSlot) => aiSlot.narrations)
        )
      : []
)
